.button {
  border: 0;
  background-color: #fff;
  cursor: pointer;
  border-radius: 8px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    svg {
      fill: rgba(234, 27, 10, 0.76);
    }
  }

  &--active {
    svg {
      fill: #ea1b0a;
    }
  }
}

.tooltip {
  font-size: 12px;
  line-height: 1.6
}